module.exports = __webpack_public_path__ + "img/logo-sla.11de1bb3.jpg";